import { IProps } from './SecondaryNavigation.interface';

export const defaultProps: IProps = {
  backLink: null,
  items: [
    {
      menu: {
        text: 'Tab Page',
        target: '_self',
        href: '/react-fe/tab-page/',
        title: 'Tab Page',
        ariaLabel: 'Tab Page',
      },
      isExpanded: false,
      isSelected: false,
      subMenu: [],
    },
    {
      menu: {
        text: 'Search Landing',
        target: '_self',
        href: '/react-fe/search-landing/',
        title: 'Search Landing',
        ariaLabel: 'Search Landing',
      },
      isExpanded: false,
      isSelected: false,
      subMenu: [
        {
          menu: {
            text: 'Donation Page',
            target: '_self',
            href: '/react-fe/donation-page/',
            title: 'Donation Page',
            ariaLabel: 'Donation Page',
          },
          isExpanded: false,
          isSelected: false,
          subMenu: [],
        },
        {
          menu: {
            text: 'Two Column Page',
            target: '_self',
            href: '/react-fe/two-column-page/',
            title: 'Two Column Page',
            ariaLabel: 'Two Column Page',
          },
          isExpanded: true,
          isSelected: true,
          subMenu: [],
        },
      ],
    },
    {
      menu: {
        text: 'Donation Page',
        target: '_self',
        href: '/react-fe/donation-page/',
        title: 'Donation Page',
        ariaLabel: 'Donation Page',
      },
      isExpanded: false,
      isSelected: false,
      subMenu: [],
    },
    {
      menu: {
        text: 'Two Column Page',
        target: '_self',
        href: '/react-fe/two-column-page/',
        title: 'Two Column Page',
        ariaLabel: 'Two Column Page',
      },
      isExpanded: true,
      isSelected: true,
      subMenu: [],
    },
    {
      menu: {
        text: 'One Column Page',
        target: '_self',
        href: '/react-fe/one-column-page/',
        title: 'One Column Page',
        ariaLabel: 'One Column Page',
      },
      isExpanded: false,
      isSelected: false,
      subMenu: [],
    },
  ],
};
